import React, { useEffect, useState } from 'react';
import NiceModal from '@ebay/nice-modal-react';

import BotStatusIcon from '../statuses/BotStatus';
import MintingStatusIcon from '../statuses/MintingStatus';
import HandFreeWhiteIcon from '@images/owner/ic_search_hands_free_white.svg';
import LinkIcon from '@images/owner/link.svg';
import CheckIcon from '@images/owner/check.svg';
import ShareEarthRoverModal from '@components/Modal/ShareEarthRoverModal';
import { getStatusRide } from '@services/api';
import AutoAwesomeIcon from '@images/owner/autoAwesome.svg';

const OwnerBotCard = ({ bot, handleBotSelection, index, setBotDeviceId, botDeviceId, isTournament }) => {
	const [currentDriveUserName, setCurrentDriveUserName] = useState('');

	useEffect(() => {
		if (bot?.current_ride_id) {
			currentDriveUserNameFindHandler();
		}
	}, [bot]);

	const handleBotSelectionActivity = async () => {
		setBotDeviceId(bot?.device_ref_id);
	};

	const shareHandler = (shareBot) => {
		NiceModal.show(ShareEarthRoverModal, { shareBot });
	};

	const currentDriveUserNameFindHandler = async () => {
		if (bot?.current_ride_id) {
			const getRide = await getStatusRide(bot?.current_ride_id);
			if (getRide?.ride) {
				setCurrentDriveUserName(getRide?.ride?.username);
			}
		}
	};

	const drivingUserName = currentDriveUserName ? `${currentDriveUserName} is driving...` : 'is driving...';
	const isRentedBySam = bot.active_with_sam;

	const renderDriveButtons = (isRentedBySam) => {
		const buttonStyles = {
			base: 'flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px]',
			ready: 'border-[1px] border-solid border-[#25BD66] bg-[#008735] disabled:opacity-50',
			inProgress: 'border-[1px] border-solid border-[#BBE8C5] bg-[#BBE8C5] disabled:opacity-50'
		};

		const getButtonConfigs = (handler, icon, text, isRentedBySam) => ({
			personal_ready: {
				className: `${buttonStyles.base} ${buttonStyles.ready} ${bot.status === 'offline' ? 'opacity-50' : ''}`,
				content: (
					<>
						<img
							src={icon}
							alt={`${text.toLowerCase()}-icon`}
						/>
						<p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
							{text}
						</p>
					</>
				),
				disabled: bot.status === 'offline' || isRentedBySam,
				handler
			},
			mission_in_progress: {
				className: `${buttonStyles.base} ${buttonStyles.inProgress} ${bot.status === 'offline' ? 'opacity-50' : ''}`,
				content: (
					<p className="text-[#007126] text-[14px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
						{drivingUserName}
					</p>
				),
				disabled: bot.status === 'offline' || isRentedBySam,
				handler
			},
			default: {
				className: `${buttonStyles.base} ${buttonStyles.ready} ${bot.status === 'offline' ? 'opacity-50' : ''}`,
				content: (
					<>
						<img
							src={icon}
							alt={`${text.toLowerCase()}-icon`}
						/>
						<p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
							{text}
						</p>
					</>
				),
				disabled: bot.status === 'offline' || bot.status === 'mission_ready' || isRentedBySam,
				handler
			}
		});

		const regularDriveConfig = getButtonConfigs(() => handleBotSelection(bot), HandFreeWhiteIcon, 'Drive', isRentedBySam);

		const regularConfig = regularDriveConfig[bot.status] || regularDriveConfig.default;

		return (
			<>
				<button
					className={regularConfig.className}
					onClick={regularConfig.handler}
					disabled={regularConfig.disabled}
				>
					{regularConfig.content}
				</button>
			</>
		);
	};

	return (
		<div
			className="w-full sm:w-[512px] bg-white rounded-xl overflow-hidden shadow-lg cursor-pointer"
			style={{ border: isRentedBySam ? '4px solid #e8b923' : botDeviceId === bot?.device_ref_id && '1px solid #25BD66' }}
			key={index}
			onClick={() => handleBotSelectionActivity(bot)}
		>
			<div className="w-full flex p-[16px] flex-col items-start gap-[16px]">
				<div className="w-full flex pb-[16px] items-end border-b-[1px] border-b-solid border-b-[#DDD]">
					<div className="flex items-center gap-[16px]">
						<BotStatusIcon
							status={bot.status}
							className="w-[50px]"
						/>
						<div className="flex justify-center items-center gap-[6px]">
							<div className='flex flex-col gap-[6px]'>
								<div className='flex justify-center items-center gap-[6px]'>
									<p className="text-[#000] text-center text-[24px] not-italic font-semibold leading-[normal] tracking-[-0.96px]">{bot.name}</p>
									<MintingStatusIcon status={bot.bot_activation?.minting_status} />
								</div>
								{isRentedBySam &&
									<p className='text-[#e8b923] text-left text-[14px] not-italic font-semibold leading-[20px] tracking-[-0.64px]'>Currently Rented by SAM</p>
								}
							</div>
						</div>
					</div>
				</div>
				<div className="w-full flex flex-col sm:flex-row justify-between gap-[16px] sm:gap-0">
					<div className="flex items-start flex-wrap gap-[8px]">
						{renderDriveButtons(isRentedBySam)}
						{!isTournament && (
							<button
								className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#727272] bg-[#000] disabled:opacity-50"
								onClick={() => shareHandler(bot)}
								disabled={isRentedBySam}
							>
								<img
									src={LinkIcon}
									alt="link-icon"
								/>
								<p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
									Share
								</p>
							</button>
						)}
					</div>

					{bot.status === 'personal_ready' && (
						<div className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px]">
							<img
								src={CheckIcon}
								alt="check-icon"
							/>
							<p className="text-[#25BD66] text-[14px] not-italic font-medium leading-[20px] tracking-[-0.64px]">
								Ready to drive!
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default OwnerBotCard;